import { useUser, useSelectedCompanyId } from '@/contexts/UserSession';

const useAbilityUtils = () => {
    const user = useUser(true);
    const selectedCompanyId = useSelectedCompanyId();
    const isSuperAdmin = user?.isSuperAdmin || false;

    // Helper to check if SuperAdmin has a company selected from JWT token
    const hasSuperAdminCompanySelected = () => {
        if (user?.__typename !== 'SuperAdminUser') {
            return false;
        }
        return !!selectedCompanyId;
    };

    const grantSuperAdmin =
        <Args extends any[]>(fn: (...args: Args) => boolean, requiresCompanySelection = false) =>
        (...args: Args): boolean => {
            if (isSuperAdmin) {
                // If company selection is required, check if SuperAdmin has selected a company
                if (requiresCompanySelection) {
                    return hasSuperAdminCompanySelected();
                }
                return true;
            }
            return fn(...args);
        };

    return {
        user,
        isSuperAdmin,
        hasSuperAdminCompanySelected,
        grantSuperAdmin,
    };
};

export default useAbilityUtils;
